import { Flex } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { CircleCheckIcon } from '@/shared/ui';

const StrongSides = () => {
  const { t } = useTranslation();
  const items = t('pricingPage.strongSides', { returnObjects: true }) as string[];

  return (
    <Flex
      mt='lg'
      gap={{ base: 'md', md: '2xl' }}
      alignSelf='center'
      flexDir={{ base: 'column', md: 'row' }}
    >
      {items.map((item) => (
        <Flex
          key={item}
          alignItems='center'
          fontSize='lg'
          gap='1'
        >
          <CircleCheckIcon
            boxSize={6}
            color='green'
          />
          {item}
        </Flex>
      ))}
    </Flex>
  );
};

export default StrongSides;
